import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-update-notification',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './update-notification.component.html',
  styleUrls: ['./update-notification.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideIn', [
      state('void', style({
        transform: 'translateX(120%)',
        opacity: 0
      })),
      state('*', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('void => *', animate('400ms cubic-bezier(0.34, 1.56, 0.64, 1)')),
      transition('* => void', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({
        transform: 'translateX(120%)',
        opacity: 0
      })))
    ])
  ]
})
export class UpdateNotificationComponent implements OnInit, OnDestroy {
  visible = true;
  private destroy$ = new Subject<void>();

  // Callbacks für Button-Aktionen
  onUpdateNow?: () => void;
  onUpdateLater?: () => void;

  ngOnInit(): void {
    // Kleine Verzögerung für die Einblend-Animation
    setTimeout(() => {
      this.visible = true;
    }, 100);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleUpdateNow(): void {
    this.visible = false;
    setTimeout(() => {
      if (this.onUpdateNow) {
        this.onUpdateNow();
      }
    }, 300);
  }

  handleUpdateLater(): void {
    this.visible = false;
    setTimeout(() => {
      if (this.onUpdateLater) {
        this.onUpdateLater();
      }
    }, 300);
  }

  close(): void {
    this.handleUpdateLater();
  }
}
